import { Option } from '../../general-types';
import { Flags, ValueOfKey } from '../../utils-types';

export const CHALLENGE_STATUS = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  FINISHED: 'FINISHED',
  PUBLISHED: 'PUBLISHED',
} as const;

export type ChallengeStatusType = ValueOfKey<typeof CHALLENGE_STATUS>;
export type ChallengeStatusFlags = Flags<ChallengeStatusType>;

export const challengeStatusOptions: Option<ChallengeStatusType | ''>[] = [
  { value: '', label: 'All' },
  { value: CHALLENGE_STATUS.ACTIVE, label: 'Active' },
  { value: CHALLENGE_STATUS.DRAFT, label: 'Draft' },
  { value: CHALLENGE_STATUS.FINISHED, label: 'Finished' },
  { value: CHALLENGE_STATUS.PUBLISHED, label: 'Published' },
];
